import { IconProps } from './icons-props';

function ShieldIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12 22.7599C10.91 22.7599 9.83002 22.4399 8.98002 21.8099L4.68002 18.5999C3.54002 17.7499 2.65002 15.9699 2.65002 14.5599V7.11994C2.65002 5.57994 3.78002 3.93994 5.23002 3.39994L10.22 1.52994C11.21 1.15994 12.77 1.15994 13.76 1.52994L18.75 3.39994C20.2 3.93994 21.33 5.57994 21.33 7.11994V14.5499C21.33 15.9699 20.44 17.7399 19.3 18.5899L15 21.7999C14.17 22.4399 13.09 22.7599 12 22.7599ZM10.75 2.93994L5.76002 4.80994C4.91002 5.12994 4.16002 6.20994 4.16002 7.12994V14.5599C4.16002 15.5099 4.83002 16.8399 5.58002 17.3999L9.88002 20.6099C11.03 21.4699 12.97 21.4699 14.13 20.6099L18.43 17.3999C19.19 16.8299 19.85 15.5099 19.85 14.5599V7.11994C19.85 6.20994 19.1 5.12994 18.25 4.79994L13.26 2.92994C12.58 2.68994 11.42 2.68994 10.75 2.93994Z'
                fill='currentColor'
            />
            <path
                d='M10.66 14.2301C10.47 14.2301 10.28 14.1601 10.13 14.0101L8.51999 12.4001C8.22999 12.1101 8.22999 11.6301 8.51999 11.3401C8.80999 11.0501 9.28999 11.0501 9.57999 11.3401L10.66 12.4201L14.43 8.65012C14.72 8.36012 15.2 8.36012 15.49 8.65012C15.78 8.94012 15.78 9.42012 15.49 9.71012L11.19 14.0101C11.04 14.1601 10.85 14.2301 10.66 14.2301Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default ShieldIcon;

